import React from 'react'
import classnames from 'classnames'
import { delay } from 'lodash'
import { Button, Text } from 'src/Components'
import withComposedClassName from 'src/composables/withComposedClassName'

import styles from './Dropdown.module.scss'

const Root = withComposedClassName(styles.container)('div')

const Dropdown = ({
  className,
  open,
  setOpen,
  buttonProps,
  headline,
  children
}) => (
  <Root className={className}>
    <Button
      minimal
      onClick={() => setOpen(!open)}
      onBlur={() => delay(() => setOpen(false), 100)}
      {...buttonProps}
      className={classnames(styles.button, buttonProps.className)}
    />
    <div
      className={classnames(styles.notificationContainer, {
        [styles.open]: open
      })}
    >
      <Text element='h3' size='m' color='quiet'>
        {headline}
      </Text>
      {children}
    </div>
  </Root>
)

export default Dropdown
